import noUiSlider from 'nouislider'

import updateArrowPosition from '../common/components/updateArrowPosition'

let currentSliderSteps
let slider
let $arrow

const addComma = function(number)
{
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Callback for the slider move event
 *
 * @param values
 */

const onSliderMove = function(values)
{

    // Get the value
    const value = parseFloat(values[0])

    // Get the product
    const product = currentSliderSteps.references[value]

    // Update product subtotal
    updateProductSubtotal(product)

    // Update the product total
    updateProductTotal(product)

}

export const destroySlider = function()
{
    if(slider)
    {
        slider.destroy()
        slider = null
    }
}

/**
 * Create or update the slider instance
 *
 * @param sliderSteps
 */

export const createOrUpdateSlider = function(sliderSteps = null, sliderId = 'slider-range', options)
{

    // Get the slider
    const rangeSlider = document.getElementById(sliderId)

    // Stop if no slider found
    if(!rangeSlider) return

    // Prepare the slider options
    const sliderOptions = {
        start: sliderSteps.range.min,
        connect: 'lower',
        snap: true,
        range: sliderSteps.range
    }

    // Reset options
    if(options){
        for (const optionsKey in options) {
            sliderOptions[optionsKey] = options[optionsKey]
        }
    }

    // Store the slider steps
    currentSliderSteps = sliderSteps

    if(slider){
        slider.updateOptions(sliderOptions, true)
    } else {
        sliderOptions.start = parseInt(window.activeProduct.title.split(' ')[0])
        slider = noUiSlider.create(rangeSlider, sliderOptions)
        slider.on('slide', onSliderMove)
    }

}

/**
 * Return the slider steps
 *
 * @param products
 * @param categoryId
 */

export const getSliderSteps = function(products, categoryId)
{

    // For storing the processed data
    const data = {steps: [], references: {}, range: {}, firstProduct: {}, title: null}

    let counter = 0

    // For each product
    products.forEach((product, index) => {

        // Move of if the category doesn't match
        if(product.product_category_id !== parseInt(categoryId)) return

        // Get the title parts
        const titleParts = product.title.split(' ')

        // Get the quantity
        const quantity = parseInt(titleParts[0])

        // If the first item
        if(counter === 0) {

            // Store the first product
            data.firstProduct = product

            // Store the product title
            data.title = product.title

        }

        // Store the step data
        data.steps.push({
            id: product.product_id,
            title: product.title,
            description: product.description,
            comment: product.comment,
            price: product.price,
            base_price: product.base_price,
            quantity: quantity
        })

        counter++

    })

    // Get the flat list
    const flat = data.steps.length

    // Get the step size
    const step = 100 / (flat - 1)

    // For each step
    for(let i = 0; i < flat; i++) {

        // Store the step reference
        data.references[data.steps[i].quantity] = data.steps[i]

        let key = (i * step).toFixed(2) + '%'

        if(i === 0) key = 'min'
        if(i === flat - 1) key = 'max'

        data.range[key] = data.steps[i].quantity

    }

    // Return the data
    return data

}

function numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

/**
 * Update the order total
 *
 * @param product
 */

const updateProductTotal = function(product)
{

    // Get the action card
    const $actionCard = $('#action-card')

    // Get the order summary
    const $orderSummary = $('.summary', $actionCard)

    // Stop if no order summary
    if($orderSummary.length === 0) return

    // Update the product title
    $orderSummary.find('.title-price span:first-child').text(numberWithCommas(product.title))

    // Update the price
    $orderSummary.find('.title-price span:last-child').text('$' + addComma(product.price))

    // Set the total price
    let total = product.price

    // If we have a coupon
    if(window.coupon && window.coupon['discount_amount']) {

        // Get the discount amount
        const discountAmount = window.coupon['discount_amount']

        // Calculate the new total
        total = (window.coupon['discount_type'] === 'percentage') ? total - total * discountAmount  : total - discountAmount

    }

    // Update the service key
    if(product.service) $actionCard.find('#order_service').val(product.service.key)

    // Update the product id
    if(product.product_id || product.id) $actionCard.find('#order_product_id').val(product.product_id || product.id)

    // Update the order total
    $orderSummary.find('.total span:last-child').text('$' + addComma(total))

    // Update the product name
    $orderSummary.find('.title-price span:first-child').text(numberWithCommas(product.title))

    activateWebsrapingSendBtn($orderSummary, product)
}

/**
 * Update product subtotal
 *
 * @param product
 */

const updateProductSubtotal = function(product)
{

    // Get the subtotal
    const $subtotal = $('#subtotal', $('#product-details'))

    let title = numberWithCommas(product.title)

    // Update the product title
    $subtotal.find('.title').text(title)

    // Update the price
    $subtotal.find('.price').text(addComma(product.price))

    const $base_price = $subtotal.find('.base-price .value');
    if ($base_price.length) {
        $base_price.text(addComma(product.base_price))
    }

}

/**
 * Update the product details card
 *
 * @param serviceId
 * @param categoryId
 */

const updateProductDetails = function(serviceId, categoryId)
{

    // Get the product details card
    const $productDetails = $('#product-details')

    // Get the slider values
    const $sliderValues = $('#slider-values', $productDetails)

    // Get descriptions
    const $descriptions = $('.descriptions')

    // Get the steps data
    const stepsData = getSliderSteps(window.services[serviceId]['products'], categoryId)

    // Get the minimum product quantity
    const minQuantity = stepsData.range.min

    // Update the minimum slider value
    $sliderValues.find('span:first-child').text(minQuantity)

    // Update the maximum slider value
    $sliderValues.find('span:last-child').text(addComma(parseInt(stepsData.range.max)))

    // Update the product subtotal
    updateProductSubtotal(stepsData.firstProduct)

    // Remove the active description
    $descriptions.find('.description.active').removeClass('active')

    // Show the new description
    $descriptions.find('.description[data-id="' + serviceId + '-' + categoryId + '"]').addClass('active')

    // Update product total
    updateProductTotal(stepsData.firstProduct)

}

const activateWebsrapingSendBtn = function($orderSummary, product)
{
    if($orderSummary.hasClass('upgrading-summary'))
    {
        const btn = $orderSummary.parent('div').find('button[type="submit"]')

        if(btn)
        {
            if(product.id && window.activeProduct.product_id
                && product.id !== window.activeProduct.product_id)
            {
                btn.prop('disabled', false);
                return true
            }
            btn.prop('disabled', true);
        }
    }
    return false
}

/**
 * Handle the package change event
 *
 * @param event
 */

const onPackageChange = function(event)
{
    // Prevent the default action
    event.preventDefault()

    // Get the package
    const $package = $(this)

    // Stop if the package is already active
    if($package.hasClass('active')) return

    // Get the slider
    const $slider = $package.parents('.swiper-container')

    // Get the package index
    const index = $package.parent().index()

    // Get the swiper
    const swiper = $slider[0].swiper

    // Center the clicked slide
    swiper.slideTo(index)

    // Remove the old active package
    $package.parents().find('.package.active').removeClass('active')

    // Mark the package as active
    $package.addClass('active')

    // Get the service Id
    const serviceId = $package.data('service')

    // Get the category Id
    const categoryId = $package.data('category')

    // Get the slider data
    const sliderData = getSliderSteps(window.services[serviceId].products, categoryId)

    // Reset the slider bar
    $('.noUi-connects').removeAttr('style')

    // Update the product details block
    updateProductDetails(serviceId, categoryId)

    // Update slider
    createOrUpdateSlider(sliderData)

    // If desktop
    if(window.innerWidth >= 1024) updateArrowPosition(index)

}

/**
 * Update the arrow position on window resize
 *
 * @return mixed
 */

const onWindowResize = function()
{

    // Get the window width
    const windowWidth = $(window).outerWidth()

    // Reset the arrow position on small devices
    if(windowWidth < 1024) return $arrow.removeAttr('style')

    // Update the arrow position
    updateArrowPosition($('.swiper-slide.swiper-slide-active').index())

}

export default function(app)
{

    // Stop if no services
    if(!window.services) return

    // Get the range slider
    const rangeSlider = document.getElementById('slider-range')

    // Stop if no range slider
    if(!rangeSlider) return

    // Create the slider instance
    createOrUpdateSlider(getSliderSteps(window.services[window.current_service].products, rangeSlider.getAttribute('data-category')))

    // Get the body
    const $body = $('body')

    // Store the arrow element
    $arrow = $('#product-details').find('.arrow')

    // Handle the package change event
    $body.on('click', '#packages-list .package', onPackageChange)

    // Update the arrow position on window resize
    $(window).resize(onWindowResize)

}
